import { h, Component } from 'preact';
import style from './style.less'; 
import {connect} from 'react-redux'
import {Form, I18n, Row, Col, Container, Button} from 'components/elements'
import dayjs from 'dayjs'
import { times } from 'lib/helpers';
import {FilterActions, LocaleActions} from 'actions'

@Form
@connect((state)=> state)
export default class AppointmentFilter extends Component { 
	constructor(){
        super()
        this.handleAuthenticatorBlur = this.handleAuthenticatorBlur.bind(this)
        this.handleAuthenticatorChange = this.handleAuthenticatorChange.bind(this)
        this.handlePatientCount = this.handlePatientCount.bind(this)
        this.handleAppointmentType = this.handleAppointmentType.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setFilter = this.setFilter.bind(this)
        this.pleaseAddPatient = this.pleaseAddPatient.bind(this)
        this.filterSubmitSpinner = this.filterSubmitSpinner.bind(this)
	}

    handleAuthenticatorBlur(e){
        let _data = {authenticator: e.target.value}
        this.setFilter({..._data})
        this.authenticator.onBlur && this.authenticator.onBlur(e)
    }
    handleAuthenticatorChange(e){
        e.preventDefault()
        this.authenticator.onChange && this.authenticator.onChange(e)
    }

    handlePatientCount(patientCount){
        let _data = {patientCount}
        this.setFilter({..._data})
    }

    handleAppointmentType(appointmentTypeID){
        let _data = {appointmentTypeID}
        if(appointmentTypeID && !this.appointmentTypes.data.some((appType)=> appType.id == appointmentTypeID)){
            _data.appointmentTypeID = ''
        }
        this.setFilter({..._data})
    }

    handleDate(date){
        let _data = {}
        _data.startDate = dayjs(date).format("MM/DD/YYYY")
        this.setFilter({..._data})
    }

    handleSubmit(formData){
        this.setFilter({...formData})
        this.props.onSubmit && this.props.onSubmit(formData)
    }

    setFilter(data){
        FilterActions.set({
            ...this.props.filters,
            ...data
        })
        this.props.onChange && this.props.onChange(data)
        this.setState({})
    }   

    filterSubmitSpinner(){
        return this.props.loading.organization || this.props.loading.patientData
    }

    pleaseAddPatient(){
        if(this.props.disabled && this.props.placeholderAppointment){
            return <I18n>pleaseAddAPatient</I18n>
        }
        return <I18n>go</I18n>
    }

    get appointmentTypes(){
        if(this.props.appointmentTypeFilters){
            let data = this.props.appointmentTypeFilters.data.map((appType)=>{
                appType.value = appType.id
                return appType
            })
            let initialValue = this.props.appointmentTypeFilters.initialValue
            let handler = this.props.appointmentTypeFilters.handler || (()=>{})
            let required = this.props.appointmentTypeFilters.required
            let span = this.props.appointmentTypeFilters.span
            return {data, initialValue, handler, required, span}
        }
    }

    get patientCount(){
        let appointmentTypes = Object.values(this.props.appointmentTypes) || []
        let maxPatients = 1
        appointmentTypes.forEach((appointmentType)=>{
            if(appointmentType.durations && appointmentType.durations.split(',').length > maxPatients){
                maxPatients = appointmentType.durations.split(',').length
            }
        })
        
        let patientType = 'Pet'
        if(this.props.config.genericPatients){
            patientType = 'Patient'
        }
        let data = [{name:`1 ${patientType}`,value:1}]
        data = data.concat(times(maxPatients - 1).map((i)=>{
            return {name:`${i + 2} ${patientType}s`,value:i + 2}
        }))
        if(this.props.PatientCountFilters){
            let initialValue = this.props.PatientCountFilters.initialValue
            let handler = this.props.PatientCountFilters.handler || (()=>{})
            let required = this.props.PatientCountFilters.required
            let span = this.props.PatientCountFilters.span
            return {data, initialValue, handler, required, span}
        }
    }

    get authenticator(){
        return this.props.authenticator || ''
    }

    get date(){
        if(this.props.dateFilters){
            let initialValue = this.props.dateFilters.initialValue
            let handler = this.props.dateFilters.handler || (()=>{})
            let required = this.props.dateFilters.required
            return {initialValue, handler, required}
        }
    }

    get session(){
        return this.props.session || {}
    }

	render() {
        const {Form, SelectDark, DatePickerDark, InputDark} = this.props
		return (
            <Form onSubmit={this.handleSubmit} class={this.session.resetPassword && style.faded}>
                <Row class={this.props.class}>
                    <Col span={{sm:24,md:this.props.hideSubmit? 24 : 21}}>
                        <Container>
                            <Row>
                                {this.authenticator &&
                                    <Col span={{sm: 24, md: this.authenticator.span || 9}} class={style.noPadding}>            
                                        <InputDark class={style.height}
                                            required={this.authenticator.required}
                                            initialValue={this.authenticator.initialValue}
                                            name="authenticator" 
                                            id="filter-authenticator" 
                                            key="filter-authenticator"
                                            placeholder={I18n.t('enterYourEmailOrPhoneNumber')}
                                            onBlur={this.handleAuthenticatorBlur}
                                            onChange={this.handleAuthenticatorChange} />
                                    </Col>
                                }
                                {this.patientCount &&
                                    <Col span={{sm: 24, md: this.patientCount.span || 9}} class={style.noPadding}>            
                                        <SelectDark 
                                            required={this.patientCount.required}
                                            data={this.patientCount.data} 
                                            initialValue={this.patientCount.initialValue} 
                                            name="patientCount" 
                                            placeholder={this.props.config.genericPatients ?
                                                I18n.t('numberOfPatients')
                                            :
                                                I18n.t('numberOfPets')        
                                            }
                                            onChange={this.handlePatientCount} />
                                    </Col>
                                }
                                {this.appointmentTypes &&
                                    <Col span={{sm: 24, md: this.appointmentTypes.span || 9}} class={style.noPadding}> 
                                        <SelectDark 
                                            required={this.appointmentTypes.required}
                                            data={this.appointmentTypes.data} 
                                            initialValue={this.appointmentTypes.initialValue} 
                                            value={this.appointmentTypes.initialValue}
                                            name="appointmentTypeID" 
                                            placeholder={I18n.t("selectAnAppointmentType")}
                                            onChange={this.handleAppointmentType}
                                        />
                                    </Col>
                                }
                                {this.date &&
                                    <Col span={{sm: 24, md: 6}} class={style.noPadding}> 
                                        <DatePickerDark 
                                            required={this.date.required}
                                            name="date" 
                                            placeholder={I18n.t("desiredDateOfAppointment")}
                                            initialValue={this.date.initialValue}
                                            onChange={this.handleDate} />
                                    </Col>
                                }
                            </Row>
                        </Container>
                    </Col>
                    {!this.props.hideSubmit && 
                        [
                            <Col span={{sm:24,md:'hidden',lg:'hidden'}} >
                                <div class={style.mobileSearchButton}>
                                    <Button spinner={this.filterSubmitSpinner()} disabled={this.props.disabled ? true : false}>
                                        {this.pleaseAddPatient()}
                                    </Button>
                                </div>
                            </Col>
                        ,
                            <Col span={{sm:'hidden',md:3}}>
                                <div class={style.searchButton}>
                                    <Button spinner={this.filterSubmitSpinner()} disabled={this.props.disabled ? true : false}>
                                        {this.pleaseAddPatient()}
                                    </Button>
                                </div>
                            </Col>
                        ]
                    }
                </Row>
            </Form>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/AppointmentFilters/index.js